import { render, staticRenderFns } from "./JobIntro.vue?vue&type=template&id=41f2543c&"
import script from "./JobIntro.vue?vue&type=script&lang=js&"
export * from "./JobIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports